import { render, staticRenderFns } from "./ShareFavorites.vue?vue&type=template&id=25caaf03"
import script from "./ShareFavorites.vue?vue&type=script&lang=js"
export * from "./ShareFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports